import * as ACTION from 'actions';

export function error(state={show:false, text: ''}, action) {
    switch (action.type) {
        case ACTION.SHOW_ERROR:
            return action.error;
        case ACTION.CLOSE_ERROR:
            return {...state, show: false}
        default:
            return state;
    }
}